'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ClientShowCtrl
 * @description
 * # ClientShowCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('AppLicensesShowCtrl', [
    '$scope', '$stateParams', 'AppLicense', function ($scope, $stateParams, AppLicense) {
      $scope.app_license = {};
      AppLicense.find($stateParams.app_licenseId).then(function(response) {
        $scope.app_license = response.data.app_license;
      }, function(error) {
        AppLicense.error(error);
      });

      $scope.copyHashCode = function(value, successMessage) {
        AppLicense.copyText(value, successMessage);
      }
  }]);
